const FilterComp = ({ filter, setFilter }) => {

	const handleChange = (e) => {
		setFilter(e.target.value)
	}

	return (
		<div className="flex-1 bg-[#F9F9F9] border border-[#959595] max-w-[400px] my-2  border-solid rounded-md w-full p-2">
			<input
			    className="bg-transparent w-full"
				value={filter}
				style={{outline: "none"}}
				onInput={handleChange}
				placeholder="Search Table"
			/>
		</div>
	)
}

export default FilterComp
